// import luxy from 'luxy.js';
import ScrollTrigger from '@terwanerik/scrolltrigger';
import easing from 'jquery.easing';
// import Selectra, { createSelectra } from 'selectra';
import selectric from 'selectric';
import 'selectric/public/selectric.css';
import Cookies from 'js-cookie';

export class App {
  constructor() {
    this.html = document.documentElement;
    this.body = document.body;
    this.page = document.getElementById('page');
    this.btnH = document.getElementById('btnH');
    this.gnavH = document.getElementById('gnavH');
    //this.hero = document.getElementById('heroContainer');
    this.footer = document.querySelector('.siteFooter__btnContainer');
    this.ua = isSp(this);
    this.sp = 1000;
    this.ease = "easeInOutExpo";
    this.btn_jud = false;
    this.jud_num = 50;

    history.scrollRestoration = "manual";
    // console.log(history.scrollRestoration);



    function isSp(_t) {
      let _ua;
      if (navigator.userAgent.match(/iPhone|iPad|iPod|Android.+Mobile/)) {
        _ua = "mobile";
        //_t.makeSp();
        //console.log(_t);
      } else {
        _ua = "other";
      }
      //_t.body.classList.add(_ua);
      return _ua;
    }

  }
  init() {


    this.navBack = document.createElement('div');
    this.navBack.classList.add('navBack');
    this.gnavH.querySelector('.gnavH__container').appendChild(this.navBack);

    if (this.body.classList.contains('top')) {
      const visit = Cookies.get('visit');
      if (!visit) {
        // this.menuopen();
        // Cookies.set('visit', true);
      }
      this.judgeElm = document.querySelector('.siteHeader__inner');
      this.fstAnimEl = [];
      this.fstAnimEl.push(document.getElementById('siteHeaderTitle'));
      this.fstAnimEl.push(document.getElementById('siteHeaderText'));
      //this.fstAnimEl.push(document.getElementById('listWrap'));
    }

    window.addEventListener('load', (e) => {

      const _this = this;

      //setTimeout(() => {

      // this.resize();
      // this.scroll();
      this.body.classList.add('loaded');
      this.page.classList.add('on');
      $('.spinner').fadeOut('slow', function () {
        $(this).remove();
        if (_this.body.classList.contains('top')) {
          _this.firstEvent();
        }
        _this.comEvent();
      });

      let url = location.href;
      if (url.indexOf('?id=') != -1) {
        let _id = url.split("?id=");
        let _tar = _id[_id.length - 1];
        let _el = document.getElementById(_tar);
        setTimeout((e) => {
          this.anim(_el);
        }, 100);
      }
      //console.log(url);
      // document.querySelector('.hero_image').classList.add('on');
      // if(_this.body.classList.contains('home')){
      //   if(ref_jud){
      //     _this.hero_swiper.autoplay.start();
      //   }
      // }
      this.events();
      //}, 500);
    });

    if (this.body.classList.contains('top')) {
      this.trigger();
    }

    // luxy.init({
    //   wrapper: "#page",
    //   targets: '.lxel',
    //   wrapperSpeed: 0.098//0.095
    // });


  }
  comEvent() {
    setTimeout((e) => {
      this.footer.classList.add('on');
    }, 500);
  }

  firstEvent() {
    if (this.judgeElm.classList.contains('animIn')) {
      for (const el of this.fstAnimEl) {
        el.classList.add('on');
      }
      setTimeout(() => {
        console.log('first');
        document.getElementById('listWrap').classList.add('on');
      }, 1100);
    }
  }

  anim(_t) {
    const rect = _t.getBoundingClientRect();
    const scT = window.pageYOffset || document.documentElement.scrollTop;
    const targetT = rect.top + scT;
    $('html,body').animate({
      scrollTop: targetT
    }, this.sp, this.ease);
  }

  scroll() {
    let scT = window.pageYOffset;
    console.log(scT);
    if (this.ua !== "other") {
      if (scT > this.jud_num) {
        if (!this.btn_jud) {
          this.btn_jud = true;
          this.btn_sp.classList.add('on');
        }
      } else {
        if (this.btn_jud) {
          this.btn_jud = false;
          this.btn_sp.classList.remove('on');
        }
      }
    }
  }

  resize() {

    this.getSize();
    if (this.ua !== "other") {

      this.hero.style.height = (this.winH - 120) + "px";
    }
  }

  getSize() {
    this.winW = window.innerWidth;
    this.winH = window.innerHeight;
  }

  menuclose() {
    this.html.classList.remove('on');
    this.gnavH.classList.remove('on');
    this.btnH.querySelector('.bar:nth-child(1)').style.animationName = "bar1";
    this.btnH.querySelector('.bar:nth-child(3)').style.animationName = "bar3";
  }

  menuopen() {
    this.gnavH.classList.add('on');
    this.html.classList.add('on');
  }

  checkCookie() {
    const cookie = Cookies.get('slform');
    if (!cookie) {
      window.location.href = base_url + "/contact";
    }
  }

  events() {
    this.btnH.addEventListener('click', (e) => {
      if (!this.gnavH.classList.contains('on')) {
        this.menuopen();
      } else {
        this.menuclose();
      }
    });

    this.navBack.addEventListener('click', (e) => {
      this.menuclose();
    });

    if (this.body.classList.contains('policy')) {
      const btn_hs = document.getElementById('btn_hs');
      console.log(history.length);
      console.log(history);
      let _href = "";//base_url;
      console.log(document.referrer);
      btn_hs.addEventListener('click', (e) => {
        //history.back();
        _href = document.referrer;
        if (!document.referrer) {
          _href = base_url;
        }

        window.location.href = _href;
      });
    }

    if (this.body.classList.contains('top')) {
      // const visit = Cookies.get('visit');
      // if (!visit) {
      //   this.menuopen();
      //   Cookies.set('visit', true);
      // }
      // this.fstAnimEl = [];
      // this.fstAnimEl.push(document.getElementById('siteHeaderTitle'));
      // this.fstAnimEl.push(document.getElementById('siteHeaderText'));

      const _atags = document.querySelectorAll('#gnavH a[href*="?id="]');
      for (const _a of _atags) {
        let _href = _a.getAttribute('href');
        _href = _href.replace('?id=', '#');
        _a.setAttribute('href', _href);

      }

      const ttls = document.querySelectorAll('.blockContainer--planList .item__title');
      for (const tl of ttls) {
        let _box = document.createElement('span');
        _box.classList.add('num_box');
        tl.insertBefore(_box, tl.firstElementChild);
      }
      const btnBs = document.querySelectorAll('.btnB');
      for (const btnB of btnBs) {
        btnB.addEventListener('click', (e) => {
          this.menuclose();
          if (location.search) {
            //console.log(document.referrer);
            history.replaceState(null, null, base_url);
          }
        });
      }
    }


    if (this.body.classList.contains('contact')) {


      const check = document.getElementById('check');
      const cookie = Cookies.get('slform');
      if (cookie === "agree") {
        check.checked = true;
      }

      check.addEventListener('change', (e) => {
        console.log(e.currentTarget.checked);
        if (e.currentTarget.checked) {
          Cookies.set('slform', 'agree');
        } else {
          Cookies.remove('slform');
        }
        console.log(Cookies.get('slform'));
      });
    }
    if (this.body.classList.contains('contactform')) {

      // console.log('loadead');
      history.replaceState(null, null, null);
      window.addEventListener('popstate', function (e) {
        console.log('history back');
      });
      // console.log(history);

      $('html,body').animate({ scrollTop: 0 }, '1');
      this.checkCookie();
      const judY = 2023;
      const judM = 5;
      const judD = 15;
      const selY = document.getElementById('selYear');
      const selM = document.getElementById('selMoth');
      const selD = document.getElementById('selDay');
      let selectY = 0;
      let selectM = 0;
      let selectD = 0;
      let m_disable = false;
      let d_disable = false;

      if (this.ua === "mobile") {
        selY.addEventListener('change', (e) => {
          const _tar = e.currentTarget;
          let _index = _tar.selectedIndex;
          let _y = Number(_tar.options[_index].value);
          selectY = _y;
          changeSelect();
          // console.log(_y);
          if (_y === judY) {
            disabledM(judM);
          } else {
            if (m_disable) { clearM(); }
          }
          clearBoth();
        });
        selM.addEventListener('change', (e) => {
          const _tarM = e.currentTarget;
          let _indexM = _tarM.selectedIndex;
          let _m = Number(_tarM.options[_indexM].value);
          selectM = _m;
          changeSelect();
          clearBoth();
        });
        selD.addEventListener('change', (e) => {
          const _tarD = e.currentTarget;
          let _indexD = _tarD.selectedIndex;
          let _d = Number(_tarD.options[_indexD].value);
          selectD = _d;
          changeSelect();
        });
      }

      function disableD(_max) {
        d_disable = true;
        if (selectD < judD) {
          selD.selectedIndex = 0;
        }
        const d_ops = selD.options;
        for (let d = 1; d < _max; d++) {
          d_ops[d].disabled = true;
        }
        $(selD).selectric('refresh');
      }
      function clearD() {
        d_disable = false;
        //console.log('clearD');
        const d_ops = selD.options;
        for (const d_op of d_ops) {
          d_op.disabled = false;
        }
        $(selD).selectric('refresh');
      }

      function disabledM(_max) {
        m_disable = true;
        if (selectM < judM) {
          selM.selectedIndex = 0;
        }
        const ops = selM.options;
        for (let m = 1; m < _max; m++) {
          ops[m].disabled = true;
        }
        $(selM).selectric('refresh');
      }

      function clearM() {
        //console.log('clearM');
        m_disable = false;
        const ops = selM.options;
        for (const op of ops) {
          op.disabled = false;
        }
        $(selM).selectric('refresh');
      }

      function clearBoth() {
        if (selectY === judY && selectM === judM) {
          disableD(judD);
        } else {
          clearD();
        }
      }

      $(selY).selectric({
        onChange: (e) => {
          let _index = e.selectedIndex;
          let _y = Number(e.options[_index].value);
          selectY = _y;
          changeSelect();
          // console.log(_y);
          if (_y === judY) {
            disabledM(judM);
          } else {
            if (m_disable) { clearM(); }
          }

          clearBoth();

        }
      });

      $(selM).selectric({
        onChange: (e) => {
          let _indexM = e.selectedIndex;
          let _m = Number(e.options[_indexM].value);
          selectM = _m;
          changeSelect();

          clearBoth();

          console.log(_m);
        }
      });

      $(selD).selectric({
        onChange: (e) => {
          let _indexD = e.selectedIndex;
          let _d = Number(e.options[_indexD].value);
          selectD = _d;
          changeSelect();
          //console.log(_d);
        }
      });

      // const yNow = new Date().getFullYear();
      // const yMax = yNow + 10;
      // for (let i = yNow; i <= yMax; i++) {
      //   let opt = document.createElement('option');
      //   opt.setAttribute('value', i);
      //   opt.innerHTML = i;
      //   selY.appendChild(opt);
      // }
      // for (let n = 1; n <= 12; n++) {
      //   let optn = document.createElement('option');
      //   optn.setAttribute('value', n);
      //   optn.innerHTML = n;
      //   selM.appendChild(optn);
      // }

      // for (let j = 1; j <= 31; j++) {
      //   let optd = document.createElement('option');
      //   optd.setAttribute('value', j);
      //   optd.innerHTML = j;
      //   selD.appendChild(optd);
      // }


      this.sel = document.querySelectorAll('.item_sel');
      for (const sel of this.sel) {
        $(sel).selectric();
      }

      const _btn = document.querySelector('.btnContainer .btn[type=submit]');
      // console.log(_btn);
      const _wk_elm = document.getElementById('wk');
      _btn.addEventListener('click', (e) => {
        if(selectY != '' && selectM != '' && selectD != ''){
          // console.log(selectY, selectM, selectD);
          const _date = new Date(`${selectY}/${selectM}/${selectD}`);
          const _wk = _date.getDay();
          const _week = [ "日", "月", "火", "水", "木", "金", "土" ][_wk] ;
          // console.log(_date, _week);
          // const _field = document.querySelector('input[name=field_3901843]');
          // _field.value = _week;
        }
      });

      function changeSelect(){
        if(selectY != '' && selectM != '' && selectD != ''){
          // console.log(selectY, selectM, selectD);
          const _date = new Date(`${selectY}/${selectM}/${selectD}`);
          const _wk = _date.getDay();
          const _week = [ "日", "月", "火", "水", "木", "金", "土" ][_wk] ;
          // console.log(_date, _week);
          // _wk_elm.innerHTML = _week;
          // console.log(_wk_elm)
          // const _field = document.querySelector('input[name=field_3901843]');
          // _field.value = _week;
        }
      }
    }


    //window.addEventListener('scroll', (e) => { this.scroll(); });
    //window.addEventListener('resize',(e)=>{this.resize();});

    const atags = document.querySelectorAll("a[href^='#']");
    for (const _a of atags) {
      _a.addEventListener('click', (e) => {
        e.preventDefault();
        let href = e.currentTarget.getAttribute('href');
        if (href == "#" || href == "") {
          href = "#page";
          this.sp = 1200;
        }
        href = href.replace("#", "");
        const target = document.getElementById(href);
        setTimeout((e) => {
          this.anim(target);
        }, 100);
      });
    }

    const acs = document.querySelectorAll('.ac .title');
    for (const ac of acs) {
      // const _header = ac.closest('header');
      // const _container = _header.nextElementSibling;
      // const _mxH = _container.querySelector('.inner').offsetHeight;
      // _container.style.maxHeight = _mxH+"px";

      ac.addEventListener('click', (e) => {
        const cur = e.currentTarget;
        //console.log(cur);
        if (cur.classList.contains('on')) {
          cur.classList.remove('on');
          const _header = cur.closest('header');
          const _container = _header.nextElementSibling;
          _container.style.maxHeight = 0;
        } else {
          cur.classList.add('on');
          const _header = cur.closest('header');
          const _container = _header.nextElementSibling;
          const _maxH = _container.querySelector('.inner').offsetHeight;
          _container.style.maxHeight = _maxH + "px";
          //console.log(_maxH);
        }
      });
    }


  }
  trigger() {
    this.trigger = new ScrollTrigger({
      trigger: {
        offset: {
          viewport: {
            x: 0,
            y: (trigger, rect, direction) => {
              return 0.2;
            }
          }
        },
        toggle: {
          callback: {
            in: (trigger) => {
            },
            out: (trigger) => {
            }
          }
        }
      }
    });
    this.trigger.add('[data-scroll]', {
      once: true,
      toggle: {
        class: {
          in: 'animIn',
          out: 'animOut'
        },
        callback: {
          in: (trigger) => {
            //console.log(trigger.element);
            let elm = trigger.element;
            if (elm.classList.contains('siteHeader__inner')) {
              if (this.body.classList.contains('loaded')) {
                console.log('trigger');
                for (const el of this.fstAnimEl) {
                  el.classList.add('on');
                }
                document.getElementById('listWrap').classList.add('on');
              }
              //console.log(elm);
            } else if (elm.classList.contains('listContainer__wrap')) {
              if (this.body.classList.contains('loaded')) {
                document.getElementById('listWrap').classList.add('on');
              }
            }
          },
          out: (trigger) => {

          }
        }
      }
    })
  }
  makeSp() {
    this.btn_sp = document.createElement('div');
    this.btn_sp.classList.add('btnSp');
    this.btn_sp.innerHTML = `<div class='btnSp-inner'>
    <span class="cart"><img src="images/img_btn_under_cart.png"></span>
    <span class="text"><img src="images/img_btn_under_text.png" ></span>
    </div>`;
    this.body.appendChild(this.btn_sp);
  }
}
